import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { GridColumns, PALETTE, buildGridSx } from '../styles'

type SectionProps = {
  id: string
  title: string
  columns: GridColumns
  notice?: React.ReactNode
  children: React.ReactNode
}

const Section: React.FC<SectionProps> = ({ id, title, columns, notice, children }) => (
  <Stack component="section" gap={1} aria-labelledby={id}>
    <Typography id={id} component="h2" sx={{ fontSize: 14, fontWeight: 600, color: PALETTE.text }}>
      {title}
    </Typography>
    {notice}
    <Box sx={buildGridSx(columns, 1.5)}>
      {children}
    </Box>
  </Stack>
)

export default Section
